module.exports = __webpack_public_path__ + "img/same.0034bb08.jpg";